export const scrollToRef = (ref: React.RefObject<HTMLDivElement>) =>
    ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
